/* eslint-disable import/prefer-default-export */

export class Api {
  constructor(endpoint = '') {
    this.endpoint = `${process.env.VUE_APP_API_BASE_URL}/${endpoint}`;
    this.query = {};
  }

  where(key, value) {
    this.query[key] = value;

    return this;
  }

  get queryComponent() {
    const { query } = this;

    if (!query) {
      return '';
    }

    return `?${Object.entries(query).map(entry => entry.map(encodeURIComponent).join('=')).join('&')}`;
  }

  async get() {
    return (await fetch(`${this.endpoint}${this.queryComponent}`)).json();
  }

  async first() {
    this.query.per_page = 2;

    return (await this.get())[0];
  }
}

export class Model {
  constructor(data) {
    Object.assign(this, this.cleanData(data));
  }

  static cleanData(data) {
    return data;
  }

  static all() {
    return new Api(this.endpoint).where('per_page', 100).get();
  }

  static async find(id) {
    return new Api(`${this.endpoint}/${id}`).get();
  }

  static where(key, value) {
    return new Api(this.endpoint).where(key, value);
  }
}

function cleanQuery(query) {
  if (!query) {
    return '';
  }

  return `?${Object.entries(query).map(entry => entry.map(encodeURIComponent).join('=')).join('&')}`;
}

export async function fetchJson({ path, query }) {
  return (await fetch(
    `${process.env.VUE_APP_API_BASE_URL}/${path}${cleanQuery(query)}`,
    { mode: 'cors' },
  )).json();
}

export async function fetchWp({ path, query }) {
  return fetchJson({ path: `wp/v2/${path}`, query });
}
